/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendFeedbackDto } from '../models/backend-feedback-dto';
import { feedbackCreateCreate } from '../fn/feedback/feedback-create-create';
import { feedbackCreateCreate$FormData } from '../fn/feedback/feedback-create-create-form-data';
import { FeedbackCreateCreate$FormData$Params } from '../fn/feedback/feedback-create-create-form-data';
import { FeedbackCreateCreate$Params } from '../fn/feedback/feedback-create-create';
import { feedbackCreateCreate$XWwwFormUrlencoded } from '../fn/feedback/feedback-create-create-x-www-form-urlencoded';
import { FeedbackCreateCreate$XWwwFormUrlencoded$Params } from '../fn/feedback/feedback-create-create-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiFeedbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `feedbackCreateCreate()` */
  static readonly FeedbackCreateCreatePath = '/api/feedback/create/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `feedbackCreateCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  feedbackCreateCreate$Response(
    params: FeedbackCreateCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendFeedbackDto>> {
    return feedbackCreateCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `feedbackCreateCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  feedbackCreateCreate(params: FeedbackCreateCreate$Params, context?: HttpContext): Observable<BackendFeedbackDto> {
    return this.feedbackCreateCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendFeedbackDto>): BackendFeedbackDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `feedbackCreateCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  feedbackCreateCreate$XWwwFormUrlencoded$Response(
    params: FeedbackCreateCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendFeedbackDto>> {
    return feedbackCreateCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `feedbackCreateCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  feedbackCreateCreate$XWwwFormUrlencoded(
    params: FeedbackCreateCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendFeedbackDto> {
    return this.feedbackCreateCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendFeedbackDto>): BackendFeedbackDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `feedbackCreateCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  feedbackCreateCreate$FormData$Response(
    params: FeedbackCreateCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendFeedbackDto>> {
    return feedbackCreateCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `feedbackCreateCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  feedbackCreateCreate$FormData(
    params: FeedbackCreateCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendFeedbackDto> {
    return this.feedbackCreateCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendFeedbackDto>): BackendFeedbackDto => r.body),
    );
  }
}
